<div class="campaigns-container">

  <div class="header">
    <h2>Twoje kampanie</h2>

    <div class="campaigns-toolbar">
      <button mat-raised-button class="custom-button" (click)="openNew()">
        <mat-icon>add</mat-icon> Nowa kampania
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="canter">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }



  @if (error) {
    <div class="error-msg">{{ error }}</div>
  }

  @if (!loading && campaigns.length) {
    <mat-table [dataSource]="campaigns" class="campaigns-table" multiTemplateDataRows>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
        <mat-cell *matCellDef="let c">{{ c.id }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="active">
        <mat-header-cell *matHeaderCellDef>Akt.</mat-header-cell>
        <mat-cell *matCellDef="let c">
          <mat-icon [style.color]="c.active ? '#2E7D32' : '#bbb'">
            {{ c.active ? 'check_circle' : 'cancel' }}
          </mat-icon>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
        <mat-cell *matCellDef="let c">{{ c.name }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="valid">
        <mat-header-cell *matHeaderCellDef>Ważna do</mat-header-cell>
        <mat-cell *matCellDef="let c">{{ c.valid | date: 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let c" (click)="$event.stopPropagation()">
          <button mat-raised-button class="custom-button" [routerLink]="['/skanowanie', $safeNavigationMigration(c?.id)]">
            <mat-icon>qr_code_scanner</mat-icon> Skanuj
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let c; columns: displayedColumns;" class="clickable-row"
        (click)="openEdit(c)">
      </mat-row>
      <ng-container matColumnDef="statsDetail">
        <mat-cell *matCellDef="let c" [attr.colspan]="displayedColumns.length" class="stats-cell">
          <div class="campaign-stats">
            <span class="campaign-stats__item">
              <mat-icon>star</mat-icon>
              <span class="campaign-stats__label">Punkty</span>
              <span class="campaign-stats__value">{{ c.aggregation_score ?? '—' }}</span>
            </span>
            <span class="campaign-stats__item">
              <mat-icon>payments</mat-icon>
              <span class="campaign-stats__label">Kwota</span>
              <span class="campaign-stats__value">{{ c.aggregation_amount != null ? (c.aggregation_amount | number:'1.2-2') : '—' }}</span>
            </span>
            <span class="campaign-stats__item">
              <mat-icon>point_of_sale</mat-icon>
              <span class="campaign-stats__label">Transakcje</span>
              <span class="campaign-stats__value">{{ c.aggregation_transactions ?? '—' }}</span>
            </span>
            <span class="campaign-stats__item">
              <mat-icon>how_to_reg</mat-icon>
              <span class="campaign-stats__label">Wejścia</span>
              <span class="campaign-stats__value">{{ c.aggregation_entries ?? '—' }}</span>
            </span>
            <span class="campaign-stats__item">
              <mat-icon>group</mat-icon>
              <span class="campaign-stats__label">Użytkownicy</span>
              <span class="campaign-stats__value">{{ c.aggregation_users ?? '—' }}</span>
            </span>
          </div>
          <div class="campaign-stats__actions" (click)="$event.stopPropagation()">
            <a class="scans-link" (click)="openScans(c)">
              <mat-icon>receipt_long</mat-icon> Pokaż skany kart
            </a>
          </div>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let c; columns: ['statsDetail'];" class="stats-row"></mat-row>
    </mat-table>
  }

  @if (!loading && !campaigns.length && !error) {
    <p class="empty-msg">Brak kampanii.</p>
  }
</div>